export default __webpack_public_path__ + "static/media/icon-github.04be58c1.svg";